import clsx from "clsx";
import "./Title.css";

interface TitleProps {
  title: string;
  className?: string;
}

const Title: React.FC<TitleProps> = ({ title, className }) => {
  return (
    <div className={clsx("custom-title", className)}>
      <span>{title}</span>
    </div>
  );
};

export default Title;
